import glsl from 'babel-plugin-glsl/macro'

const fragmentShader = glsl`
    
    #define time u_time

    uniform sampler2D u_texture;
    uniform vec2 u_mouse2;
    uniform vec2 u_mouse3;
    
    float label(vec2 p)
    {
        p *= 10.;
        // p *= 0.01;
        p.x -= 0.25;
        // p = p +  vec2(7., 3.5);
        float left = numNine(vec2(p.x + 0.35, p.y));
        float center = numFour(vec2(p.x -0.03, p.y));
        float right = numFour(vec2(p.x - 0.42, p.y));
        return left + center + right ;
    }
    
    mat2 Rot(float a){
        float s = sin(a);
        float c = cos(a);
        return mat2(c, -s, s, c);
    }

    float sdfBox(vec2 p, vec2 b){
        vec2 d = abs(p) -b;
        return length(max(d, 0.)) + min(max(d.x, d.y), 0.);
    }

     float sdfCircle(vec2 p, float r){
        return length(p) - r;
    }

    float softMax(float a, float b, float k)
    {
        return log(exp(k * a) + exp(k * b)) / k;
    }
    
    float softMin(float a, float b, float k)
    {
        return -softMax(-a, -b, k);
    }

    float opUnion(float d1, float d2)
    {
        return min(d1, d2);
    }

    float sdfVesica(vec2 p, float w, float h)
    {
        float d = 0.5*(w*w-h*h)/h;
        p = abs(p);
        vec3 c = (w*p.y < d*(p.x-w)) ? vec3(0.0,w,0.0) : vec3(-d,0.0,d+h);
        float s = length(p-c.yx) - c.z;
        return s;
        // return smoothstep(s, s+0.01, 0.01);
    }

    float plotLine(vec2 p, float line, float thickness)
    {
        return line - p.y;
    }

    float lineSegment(vec2 p, vec2 a, vec2 b) {
        float thickness = 0.1/100.0;

        vec2 pa = p - a;
        vec2 ba = b - a;

        float h = clamp( dot(pa,ba)/dot(ba,ba), 0.0, 1.0 );
        // ????????
        float idk = length(pa - ba*h);

        return idk;
    }
    
    float opOnion(float sdf, float r)
    {
    return abs(sdf) - r;
    }

    vec2 toPolarCoords(vec2 coords, float time) {
        float radius = length(coords); //get euclidean distance
        float angle = atan(coords.y, coords.x); //get angle in radians
        angle = abs(angle * 4.4);
        vec2 polarCoords = vec2(0.15 / radius + time * 0.095, angle / PI /16. ); //polar coordinate as (radius, angle)
        return polarCoords;
    }

    vec2 tPattern(vec2 vUv, float i){
        i = fract((i-0.5) * 2.0);
        if(i > 0.75){
            vUv = vec2(1.0) - vUv;
        } else if (i > 0.5){
            vUv = vec2(1.0 - vUv.x, vUv.y);
        } else if (i > 0.25){
            vUv = 1.0 - vec2(1.0-vUv.x, vUv.y);
        }
        return vUv;
    }

    float sdPoly(vec2 p, int sides, float scale)
    {
        p = p * 2. - 1.;
        float angle = atan(p.x, p.y) + PI;
        float radius = TWO_PI/float(sides);
        float d = cos(floor(.5 + angle/ radius) * radius - angle) * length(p);
        return d;
    }

    void main()
    {
        vec2 coords = vUv;
        vec3 color;
        vec2 numCoords = coords; 

        vec2 m = u_mouse;

        vec2 cCoords1 = coords - 0.5;
        vec2 cCoords2 = coords - 0.5;
        vec2 cCoords3 = coords - 0.5;
        vec2 cCoords4 = coords - 0.5;
        vec2 cCoords5 = coords - 0.5;
        vec2 cCoords6 = coords - 0.5;
        vec2 cCoords7 = coords - 0.5;
        vec2 cCoords8 = coords - 0.5;
        vec2 cCoords9 = coords - 0.5;
        vec2 cCoords10 = coords - 0.5;

        cCoords1.x += cos(u_time * 2.05)/10.5;
        cCoords2.x += cos(u_time * 2.15)/10.5;
        cCoords3.x += cos(u_time * 2.25)/10.5;
        cCoords4.x += cos(u_time * 2.35)/10.5;
        cCoords5.x += cos(u_time * 2.45)/10.5;
        cCoords6.x += cos(u_time * 2.55)/10.5;
        cCoords7.x += cos(u_time * 2.65)/10.5;
        cCoords8.x += cos(u_time * 2.75)/10.5;
        cCoords9.x += cos(u_time * 2.85)/10.5;
        cCoords10.x+= cos(u_time * 2.95)/10.5;

        cCoords1.y +=  sin(u_time * 1.05)/10.5;
        cCoords2.y +=  sin(u_time * 1.15)/10.5;
        cCoords3.y +=  sin(u_time * 1.25)/10.5;
        cCoords4.y +=  sin(u_time * 1.35)/10.5;
        cCoords5.y +=  sin(u_time * 1.45)/10.5;
        cCoords6.y +=  sin(u_time * 1.55)/10.5;
        cCoords7.y +=  sin(u_time * 1.65)/10.5;
        cCoords8.y +=  sin(u_time * 1.75)/10.5;
        cCoords9.y +=  sin(u_time * 1.85)/10.5;
        cCoords10.y += sin(u_time * 1.95)/10.5;

        cCoords1.y -= 0.5 * 0.2;
        cCoords2.y -= 0.4 * 0.2;
        cCoords3.y -= 0.3 * 0.2;
        cCoords4.y -= 0.2 * 0.2;
        cCoords5.y -= 0.1 * 0.2;
        cCoords6.y += 0.1 * 0.2;
        cCoords7.y += 0.2 * 0.2;
        cCoords8.y += 0.3 * 0.2;
        cCoords9.y += 0.4 * 0.2;
        cCoords10.y+= 0.5 * 0.2;

        float c1 = length(cCoords1)  - 0.05;
        float c2 = length(cCoords2)  - 0.05;
        float c3 = length(cCoords3)  - 0.05;
        float c4 = length(cCoords4)  - 0.05;
        float c5 = length(cCoords5)  - 0.05;
        float c6 = length(cCoords6)  - 0.05;
        float c7 = length(cCoords7)  - 0.05;
        float c8 = length(cCoords8)  - 0.05;
        float c9 = length(cCoords9)  - 0.05;
        float c10 = length(cCoords10)- 0.05;

        // c1 = opOnion(c1, 0.0001);
        // c2 = opOnion(c2, 0.0001);
        // c3 = opOnion(c3, 0.0001);
        // c4 = opOnion(c4, 0.0001);
        // c5 = opOnion(c5, 0.0001);
        // c6 = opOnion(c6, 0.0001);
        // c7 = opOnion(c7, 0.0001);
        // c8 = opOnion(c8, 0.0001);
        // c9 = opOnion(c9, 0.0001);
        // c10 = opOnion(c10, 0.0001);

        float cTot = softMin(c1, c2,   20.0);
              cTot = softMin(c3, cTot, 20.0);
              cTot = softMin(c4, cTot, 20.0);
              cTot = softMin(c5, cTot, 20.0);
              cTot = softMin(c6, cTot, 20.0);
              cTot = softMin(c7, cTot, 20.0);
              cTot = softMin(c8, cTot, 20.0);
              cTot = softMin(c9, cTot, 20.0);
              cTot = softMin(c10, cTot, 20.0);

        color = mix(vec3(1.), color, smoothstep(0., 0.0075, cTot /2.));
        color = mix(vec3(0.), color, smoothstep(0., 0.0045, cTot));
        

        float numLabel = label(numCoords);

        color = mix(color, vec3(1.), numLabel) ;
        
        gl_FragColor = vec4(color, 1.);
    }
`

const vertexShader = glsl`
varying vec2 vUv;
uniform float u_time;
uniform vec2 u_mouse;


void main()
{
    vUv = uv;
    vec3 localSpacePosition = position;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(localSpacePosition, 1.);
}`

import { Vector2, ShaderMaterial } from 'three'
import { useRef, useEffect, useState } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import numbers from '../numLabels/numbers.js'
import preload from '../preload/preload.js'
import usefulFunctions from '../usefulFunctions/usefulFunctions.js'
import * as THREE from 'three'
import { lerp } from 'three/src/math/MathUtils.js'
import { useControls } from 'leva'
import { Text } from '@react-three/drei'

export default function Shader944() {
    const r = './Models/EnvMaps/0/';
    const urls = [
        r + 'px.jpg',
        r + 'nx.jpg',
        r + 'py.jpg',
        r + 'ny.jpg',
        r + 'pz.jpg',
        r + 'nz.jpg'];

    const textureCube = new THREE.CubeTextureLoader().load(urls)
    const loader = new THREE.TextureLoader()
    const night = loader.load('./Models/Textures/photos/forest.jpg')
    night.wrapS = THREE.MirroredRepeatWrapping
    night.wrapT = THREE.MirroredRepeatWrapping

    const DPR = Math.min(window.devicePixelRatio, 1.);

    const material = new THREE.ShaderMaterial({
        vertexShader: vertexShader,
        fragmentShader: preload + usefulFunctions + numbers + fragmentShader,
        uniforms: {
            u_cameraPosition: { value: new THREE.Vector3() },
            u_time: { type: "f", value: 1.0 },
            u_resolution: { type: "v2", value: new Vector2(window.innerWidth, window.innerHeight) },
            u_mouse: { value: new THREE.Uniform(new THREE.Vector2()) },
            u_mouse2: { value: new THREE.Uniform(new THREE.Vector2()) },
            u_mouse3: { value: new THREE.Uniform(new THREE.Vector2()) },

            u_texture: { value: night },
        },
    })

    const meshSize = 2

    const geometry = new THREE.PlaneGeometry(meshSize, meshSize, 256, 256)
    const meshRef = useRef()

    //mouse value 1
    let mouseX = 0;
    let mouseY = 0;

    //mouse value 2
    let mouseX2 = 0;
    let mouseY2 = 0;

    //mouse value 3
    let mouseX3 = 0;
    let mouseY3 = 0;


    let tempValX = 0;
    let tempValY = 0;

    let currentTime = 0

    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    const handleResize = () => {
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    let camera
    useThree((state) => {
        currentTime = state.clock.elapsedTime
        camera = state.camera
    })
    let boundingBox
    const meshSizes = {
        width: 0,
        height: 0,
        leftPixel: 0,
        rightPixel: 0,
        topPixel: 0,
        bottomPixel: 0
    }

    useEffect(() => {
        if (meshRef.current) {
            boundingBox = new THREE.Box3().setFromObject(meshRef.current)

            const topLeft = new THREE.Vector3(
                meshRef.current.position.x - meshSize / 2,
                meshRef.current.position.y + meshSize / 2,
                meshRef.current.position.z,
            )

            const bottomLeft = new THREE.Vector3(
                meshRef.current.position.x - meshSize / 2,
                meshRef.current.position.y - meshSize / 2,
                meshRef.current.position.z,
            )

            const topRight = new THREE.Vector3(
                meshRef.current.position.x + meshSize / 2,
                meshRef.current.position.y + meshSize / 2,
                meshRef.current.position.z,
            )

            const bottomRight = new THREE.Vector3(
                meshRef.current.position.x + meshSize / 2,
                meshRef.current.position.y - meshSize / 2,
                meshRef.current.position.z,
            )

            topLeft.project(camera)
            bottomLeft.project(camera)
            topRight.project(camera)
            bottomRight.project(camera)

            const topLeftX = (1 + topLeft.x) / 2 * dimensions.width
            const topLeftY = (1 - topLeft.y) / 2 * dimensions.height


            const bottomLeftX = (1 + bottomLeft.x) / 2 * dimensions.width
            const bottomLeftY = (1 - bottomLeft.y) / 2 * dimensions.height

            const topRightX = (1 + topRight.x) / 2 * dimensions.width
            const topRightY = (1 - topRight.y) / 2 * dimensions.height
            // console.log(topRightX, topRightY)

            const bottomRightX = (1 + bottomRight.x) / 2 * dimensions.width
            const bottomRightY = (1 - bottomRight.y) / 2 * dimensions.height

            const shaderWidth = topRightX - topLeftX
            const shaderHeight = bottomRightY - topRightY

            meshSizes.width = shaderWidth
            meshSizes.height = shaderHeight
            meshSizes.leftPixel = topLeftX

            meshSizes.rightPixel = topRightX
            meshSizes.topPixel = topLeftY
            meshSizes.bottomPixel = bottomRightY

            window.addEventListener('resize', handleResize, false)
        }
    }, [])

    useFrame(({ clock, camera }) => {
        material.uniforms.u_cameraPosition.value = camera.position
        material.uniforms.u_time.value = clock.elapsedTime - currentTime
        material.uniforms.u_mouse.value = new Vector2(mouseX, mouseY)
        material.uniforms.u_mouse2.value = new Vector2(mouseX2, mouseY2)
        material.uniforms.u_mouse3.value = new Vector2(mouseX3, mouseY3)
        meshRef.current.material.uniforms.u_resolution.value = new THREE.Vector2(
            dimensions.width * DPR,
            dimensions.height * DPR
        )

        mouseX = lerp(mouseX, tempValX, 0.01 * 4)
        mouseY = lerp(mouseY, tempValY, 0.01 * 4)

        mouseX2 = lerp(mouseX2, tempValX, 0.005 * 4)
        mouseY2 = lerp(mouseY2, tempValY, 0.005 * 4)

        mouseX3 = lerp(mouseX3, tempValX, 0.0025 * 4)
        mouseY3 = lerp(mouseY3, tempValY, 0.0025 * 4)

    })

    const remap = (value, low1, high1, low2, high2) => {
        return low2 + (high2 - low2) * (value - low1) / (high1 - low1)
    }

    addEventListener('mousemove', (e) => {
        if (e.clientX >= meshSizes.leftPixel && e.clientX <= meshSizes.rightPixel) {
            tempValX = remap(e.clientX, meshSizes.leftPixel, meshSizes.rightPixel, 0, 1)
        }
        if (e.clientY >= meshSizes.topPixel && e.clientY <= meshSizes.bottomPixel) {
            tempValY = remap(e.clientY, meshSizes.topPixel, meshSizes.bottomPixel, 1, 0)
        }
    })

    addEventListener('contextmenu', e => e.preventDefault())

    addEventListener('touchmove', (e) => {
        if (e.clientX >= meshSizes.leftPixel && e.clientX <= meshSizes.rightPixel) {
            tempValX = remap(e.clientX, meshSizes.leftPixel, meshSizes.rightPixel, 0, 1)
        }
        if (e.clientY >= meshSizes.topPixel && e.clientY <= meshSizes.bottomPixel) {
            tempValY = remap(e.clientY, meshSizes.topPixel, meshSizes.bottomPixel, 1, 0)
        }
    }, { passive: false })

    return (
        <>
            <mesh
                ref={meshRef}
                geometry={geometry}
                material={material}
            />
        </>
    )
}